/**
 * Normalise an email before sending it to the API.
 *
 * Mobile keyboards / autocomplete frequently append a trailing space (and
 * capitalise the first letter), which the API's `@IsEmail` validator rejects
 * with a 400 "email must be an email". Trimming + lowercasing avoids that.
 */
export const normalizeEmail = (email: string): string => email.trim().toLowerCase()
